import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createContract } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createContract,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.contracts._def }),
    });
};
